import classNames from "classnames";

export const VideoPlaceHolder = ({ videoId }: { videoId: string }) => {
  return (
    <div
      style={{
        backgroundImage: `url(https://img.youtube.com/vi/${videoId}/maxresdefault.jpg)`,
      }}
      className={classNames(
        `tw:relative tw:w-full tw:max-w-310 tw:pt-[56.25%] tw:mx-auto tw:my-0`,
        "tw:flex tw:flex-wrap tw:justify-center tw:items-center",
        "tw:rounded-[20px] tw:shadow-gray-300! tw:shadow-lg!",
        `tw:bg-cover tw:bg-no-repeat tw:bg-position-[50%] tw:h-0`,
      )}
    >
      <div className="tw:bg-[url(./assets/images/icons/atom_icon_play-circle@2x.svg)] tw:bg-contain tw:bg-no-repeat tw:w-14.75 tw:h-14.75 tw:mt-[-56.25%]" />
    </div>
  );
};
